import { Controller } from "@hotwired/stimulus"

// The payment form of an expense: cash leaves a desk's drawer the day it is
// handed over, so a desk as the source takes the date and the method fields
// away (their inputs disabled, nothing is posted) and says the payout is
// dated today. A payment dated before the latest invoice it settles asks
// for its confirmation (finance test run). The server holds the rules; this
// only keeps the form honest.
export default class extends Controller {
  static targets = ["source", "accountOnly", "deskOnly", "paidOn", "beforeInvoice"]
  static values = { today: String, latestInvoice: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const fromDesk = this.sourceTarget.value.startsWith("desk:")

    this.accountOnlyTargets.forEach((element) => {
      element.hidden = fromDesk
      element.querySelectorAll("input, select").forEach((field) => {
        field.disabled = fromDesk
      })
    })
    this.deskOnlyTargets.forEach((element) => {
      element.hidden = !fromDesk
    })
    this.refreshBeforeInvoice(fromDesk)
  }

  // ISO dates (YYYY-MM-DD) compare as strings.
  refreshBeforeInvoice(fromDesk) {
    if (!this.hasBeforeInvoiceTarget) return

    const paidOn = fromDesk || !this.hasPaidOnTarget ? this.todayValue : (this.paidOnTarget.value || this.todayValue)
    const before = this.latestInvoiceValue !== "" && paidOn < this.latestInvoiceValue

    this.beforeInvoiceTarget.hidden = !before
    this.beforeInvoiceTarget.querySelectorAll("input").forEach((field) => {
      field.disabled = !before
    })
  }
}
